import React, { Component } from 'react';
import {
  css
} from 'aphrodite';
import { Link } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { Controller } from '../../common/Controller';
import { Styles } from './Styles'
import { CommonStyles } from '../../styles/Styles';

export class Headerbar extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  render() {
    return (
      <div className={css(CommonStyles.outerHeaderContainer)}>
        <div className={css(CommonStyles.innerHeaderContainer)}>
          <div className={css(CommonStyles.headerOrgOuterContainer, Styles.headerOrgOuterContainer)}>
            <p className={css(CommonStyles.headerMemberCountContainer)}>{this.props.title}</p>
          </div>
          <div className={css(CommonStyles.headerMemberOuterContainer)}>
            <p className={css(CommonStyles.headerMemberCountContainer)}>Guests  |  {this.props.items.length} {this.props.items.length > 1 ? 'Members' : 'Member'}</p>
            <div className={css(CommonStyles.headerMemberAddContainer)} onClick={() => this.props.buttonOneAction()}>
              <img src={require('../../assets/images/person-add.svg')} className={css(CommonStyles.personAddIcon)} />
              <p className={css(CommonStyles.margin)}>{this.props.buttonOneTitle}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/screens/GuestUsersDetails/Headerbar.js